export const createListener = (ongoingRequests) => {
    return ({ data: message }) => {
        const { id } = message;
        if (id !== null) {
            const ongoingRequest = ongoingRequests.get(id);
            if (ongoingRequest !== undefined) {
                const { reject, resolve } = ongoingRequest;
                ongoingRequests.delete(id);
                if (message.error === undefined) {
                    resolve(message.result);
                }
                else {
                    reject(new Error(message.error.message));
                }
            }
        }
    };
};
//# sourceMappingURL=listener.js.map